import { z, ZodType } from 'zod'

import { consentManagementSchema } from 'features/globalSetup'
import { allowActivitiesData, auctionDelay } from 'features/globalSetup/forms/Defaults/schema'
import { prebidTimeout } from 'features/globalSetup/forms/Defaults/sections/ConsentManagementSection/components/ConsentManagementCommonFields/schema'
import { domainBidderPriorities } from 'features/globalSetup/types/bidderPriority'
import { adUnitsAttributesSchema } from 'features/inventory/domain/components/ProductAdUnitsTable'
import { SchemaDefaultProps } from './types'
import { domainBiddersToAttributes } from './utils'

const domainPrebidModulesAttributesSchema = z.object({
  domainPrebidModulesAttributes: z.record(z.string(), z.boolean()),
})

export const customAuctionDelayEnabled: ZodType<boolean> = z.boolean()
export const customPrebidTimeoutEnabled: ZodType<boolean> = z.boolean()
export const domainAmazonEnabled: ZodType<boolean> = z.boolean()
export const prebidStackEnabled: ZodType<boolean> = z.boolean()

export const schema = z
  .object({
    allowActivitiesData,
    auctionDelay,
    customAuctionDelayEnabled,
    customConsentManagementEnabled: z.boolean(),
    customizeAllowActivities: z.boolean(),
    customNonConsentTrafficMonetizationEnabled: z.boolean(),
    customPrebidTimeoutEnabled,
    domainAmazonEnabled,
    domainBiddersAttributes: z.record(
      z.string(),
      z.object({
        csEnabled: z.boolean(),
        priority: z.enum(domainBidderPriorities),
        s2sEnabled: z.boolean(),
      }),
    ),
    domainId: z.string(),
    monetizeNonConsentTraffic: z.boolean(),
    prebidStackEnabled,
    prebidTimeout,
  })
  .extend(domainPrebidModulesAttributesSchema.shape)
  .extend(adUnitsAttributesSchema.shape)
  .extend(consentManagementSchema.shape)

export type DomainPrebidModulesAttributesSchema = z.infer<
  typeof domainPrebidModulesAttributesSchema
>
export type Schema = z.infer<typeof schema>

export const schemaDefault = ({
  domain: { domainPrebidStack },
  domainBidders,
}: SchemaDefaultProps): Schema => ({
  ...domainPrebidStack,
  adUnitsAttributes: {},
  customNonConsentTrafficMonetizationEnabled:
    domainPrebidStack.customNonConsentTrafficMonetizationEnabled,
  customPrebidTimeoutEnabled: domainPrebidStack.customPrebidTimeoutEnabled ?? false,
  domainAmazonEnabled: domainPrebidStack.domainAmazonEnabled ?? false,
  domainBiddersAttributes: domainBiddersToAttributes(domainBidders),
  domainPrebidModulesAttributes: {},
})
